"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SVGIcon = function SVGIcon(_ref) {
  var color = _ref.color,
      size = _ref.size,
      verticalAlign = _ref.verticalAlign,
      style = _ref.style,
      viewBox = _ref.viewBox,
      children = _ref.children,
      title = _ref.title,
      remainProps = _objectWithoutProperties(_ref, ["color", "size", "verticalAlign", "style", "viewBox", "children", "title"]);

  var rootStyle = _objectSpread({
    verticalAlign: verticalAlign,
    fill: color,
    width: "".concat(size, "px"),
    height: "".concat(size, "px")
  }, style);

  return (
    /*#__PURE__*/
    // focusable IE specific feature
    _react["default"].createElement("svg", _extends({
      "aria-hidden": "false",
      role: "img",
      "aria-labelledby": "title",
      focusable: "false",
      style: rootStyle,
      viewBox: viewBox
    }, remainProps), /*#__PURE__*/_react["default"].createElement("title", null, title), children)
  );
};

SVGIcon.defaultProps = {
  color: 'currentColor',
  size: 20,
  style: {},
  verticalAlign: 'middle',
  viewBox: '0 0 217 217',
  title: ''
};
process.env.NODE_ENV !== "production" ? SVGIcon.propTypes = {
  /** Color code of icon */
  color: _propTypes.string,

  /** Size of icon, in `px` */
  size: _propTypes.number,
  // TODO: to define small and large icon size

  /** Additional style apply to icon */
  style: (0, _propTypes.shape)({}),

  /** Vertical align of icon, default is `middle` */
  verticalAlign: _propTypes.string,

  /** viewBox of svg */
  viewBox: _propTypes.string,
  title: _propTypes.string,
  children: _propTypes.node.isRequired // TODO: theme: filled, outlined

} : void 0;
var _default = SVGIcon;
exports["default"] = _default;